import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
//import { LoadJsService } from '../../load-js/load-js.service';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';

import { AuthenticationService } from '../../_services/authentication.service';


@Component({
  selector: 'app-addservicebulky',
  templateUrl: './addservicebulky.component.html',
  styleUrls: ['./addservicebulky.component.css']
})

export class AddservicebulkyComponent implements OnInit {

  @ViewChild('closebutton',{static: false}) closebutton;

  ViewCustomer: any = {};
  ViewProduct: any = {};
  ViewProductpgw: any = {};

  form: FormGroup;
  formpgw: FormGroup;
  data: any = {};
  datapgw: any = {};
  //futuremodel : any = [];
  futuremodel : any;

  flagging:any = {};

  formAct = this.fb.group({
    id: [''],
    productname: [''],
    
  })
  
  setdonenotes : string = '';
  permision : string[] = [];
  roles : string[] = [];
  listproduct = [];
  listproductpgw = [];
  searchproduct = '';
  searchpromo = '';
  Layanan = [];
  Layananpgw = [];
  Services = [];
  Servicelist = [];
  customer = [] ;
  detStb = [] ;
  customerid : string;
  partnerid : number;
  stbid : number;
  loading_create = false;
  activationloading = false;
  alert_failed = false;
  alert_success = false;
  table_load = false;
  table_data = false;
  isAct = "";
  ServiceIndex = null;
  errorprov = false;
  resultprov = [];
  statuserrserviceprov = [];
  msgserviceprov = [];
  emailatv : string;
  errormsgprov : string;
  OrderServices : [];
  identity : [];
  currentuser : any = {};

  producttype : number;
  billingtypeid : number;
  ButtonSavePostpaid = false;
  varmodaldone : any;

  subservices:any = [];
  datacustomers:any;

  constructor(
	  private route: ActivatedRoute,
    private fb: FormBuilder,
	  private router: Router,
	  public partnerService: ApiPartnerService,
    //public LoadJsOrder: LoadJsService,
    private formBuilder: FormBuilder,
    private Auth: AuthenticationService,
  ) {

    this.form = this.formBuilder.group({
      listproduct: new FormArray([], minSelectedCheckboxes(1)),
      
    });

    this.formpgw = this.formBuilder.group({
      
      listproductpgw: new FormArray([], minSelectedCheckboxes(1))
    });

    
    

   }

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    //console.log(this.currentuser);
    this.permision = this.currentuser.permision;
    this.roles = this.currentuser.role;
    console.log(this.roles);
  	this.loadStart();
    // console.log(this.permision);
    

  }
  
  clearFuture(){
    this.futuremodel = '';
  }
  isRole(_role){
    if (this.currentuser != null) {
            
        if (this.currentuser.role.roleName == _role) {
            return true;
        }else{
            return false;
        }
        
    }else{
      return false;
    }
  }

  loadStart() {
    this.customerid = this.route.snapshot.paramMap.get('id');
    this.setflag('view','loading',false); 
    this.setflag('view','allowed',true); 
    //this.loadCustomer(this.customerid);
    //this.loadOrderService(this.customerid);
    //this.loadProducts('?billingtype=1');
  }


  private addCheckboxes() {

     
    const listproduct = <FormArray>this.form.controls.listproduct;
    listproduct.controls = [];
    // console.log(this.ViewProduct.data);
    if (this.ViewProduct.data != undefined ) 
    {
        this.ViewProduct.data.map((o, i) => {
          const control = new FormControl(); // if first item set to true, else false

          (this.form.controls.listproduct as FormArray).push(control);
        });
    }

  }

  private addPgwCheckboxes() {

    const listproductpgw = <FormArray>this.formpgw.controls.listproductpgw;
    listproductpgw.controls = [];
    
    // console.log(this.ViewProductpgw);

    if (this.ViewProductpgw.data != undefined ) 
    {

      this.ViewProductpgw.data.map((o, i) => {
        const control = new FormControl(); // if first item set to true, else false

        (this.formpgw.controls.listproductpgw as FormArray).push(control);
      });
    }

  }

  isadmin(item: any)
  {
    /*console.log(item)

    return (item.status == false);
    */

    return this.isAdministrator();

  }

  // filter
  isAdministrator()
  {
    if (this.currentuser != null) {
            
        if (this.currentuser.role.roleName == 'Administrator') {
            return true;
        }else{
            return false;
        }
        
    }else{
      return false;
    }
  }

  isPartner()
  {
    if (this.currentuser != null) {
            
        if (this.currentuser.role.roleName == 'Partner') {
            return true;
        }else{
            return false;
        }
        
    }else{
      return false;
    }
  }

  isWIC()
  {

    if (this.currentuser != null) {
            
        if (this.currentuser.role.roleName == 'OperatorWIC' || this.currentuser.role.roleName == 'Superbranch') {
            return true;
        }else{
            return false;
        }
        
    }else{
      return false;
    }
  }

  manageByWIC()
  {
    if ( this.customer['manageby'] == 1) 
    {
      return true;
    } else {
      return false;
    }
  }


  // partner == perner id
  PartnerIsMe()
  { 
  // console.log(this.currentuser );
  // console.log('partner : '+this.partnerid );
    if (this.currentuser != null) {
        if ( this.currentuser.partner != null){    
          return ( this.partnerid == this.currentuser.partner.partnerid );
        }else{
          return false;
        }
        
    }else{
      return false;
    }
    
  }


  isNew(item: any)
  {
    return (item.servicestatus == 0);
  }

  isCustomerActive()
  {
    return (this.customer['customersts'] == 10);
  }

  isCustomerNew()
  {
    return (this.customer['customersts'] == 0);
  }

  hasService()
  {
   return (this.Services.length>0);
  }

  hasOrderService(){
    //console.log(this.OrderServices);
   return (this.OrderServices.length > 0);
  }

  isActive(item: any)
  {
    return (item.servicestatus == 1);
  }

  isNotnew(cust: any)
  {
    let id = cust.customerstatus.id
    console.log(id);
    // if (id = 0) {

    // }
    // let service = '';
    // if ( item.pairingto == null || item.pairingto == 0 ){
    //   return service;
    // }else{
    //   item.customer.services.forEach(function (value) {
    //     service += value.servicename + '\n';
    //   });

    //   return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    // }
  }

  isNotActive(item: any)
  {
    return (item.servicestatus == 2);
  }

  isPaymentQuota(item: any)
  {
    return (item.paymenttype == 1);
  }

  isPaymentPgw(item: any)
  {
    if ( !this.Auth.conf.showInProduction )
    return this.Auth.conf.showInProduction;
    
    return ( 
      (item.orderstatus == 0 || (item.orderstatus == 1 && item.prosesactive == 0)) 
      && item.paymenttype == 2);
  }

  isPaymentSubmited(item: any)
  {
    return (item.orderstatus == 1 && item.prosesactive == 1);
  }


  openPGW()
  {
    if ( !this.Auth.conf.showInProduction )
    return this.Auth.conf.showInProduction;

    return this.Auth.conf.openpgw;
    
  }

  
 
  selectedOrderServices : any;
  selectedOrderServices_ : any;

  SelectedOrderServicePGW(){
    this.selectedOrderServices_ = this.formpgw.value.listproductpgw
    .map((v, i) => v ? this.Layananpgw[i] : null)
      .filter(v => v !== null);
    console.log(this.selectedOrderServices_);
    // this.selectedOrderServices.forEach(function (value) {
    //   console.log(this.Layananpgw);
    //   // let objs = this.Layananpgw.find(obj => obj.id == value.productsale_id);
    //   //    this.selectedOrderServices_.push(objs);
    //  });
    
    // console.log(this.selectedOrderServices_);
    //console.log(this.Layananpgw);
  }

  listaccounts : any;

  onbuttonOK(){
   
    let data = {'accounts':this.datacustomers}; 
    return this.partnerService.PostAddBulky(data).subscribe((output: any) => {
      console.log(output);
      this.listaccounts = output;
      
    })
  }

  showproses:any=[];
  messagesuccess:any=[];
  messageerror:any=[];
  showLoading(i){
    if ( this.showproses[i] ){
      return true;
    }else{
      return false;
    }
  }

  showMessageSuccess(i){
    if ( this.messagesuccess[i] ){
      return this.messagesuccess[i];
    }else{
      return '';
    }
  }
  showMessageError(i){
    if ( this.messageerror[i] ){
      return this.messageerror[i];
    }else{
      return '';
    }
  }

  //{"accountid":"2100016095","services":[{"productid":623}]}
  onbuttonSubmit(){
   let data : any;
  
    console.log(this.selectedOrderServices_,this.listaccounts);
    if ( this.selectedOrderServices_ == null){
      alert('Pilih paket Dulu');
      return;
    }

    if ( this.listaccounts == null){
      alert('Accountnya tidak ada');
      return;
    }

    for (let i = 0; i < this.listaccounts.length; i++) {
      this.showproses[i] = true;
      if ( this.futuremodel == null ){
        data = {"accountid":this.listaccounts[i]['accountid'],"services":this.selectedOrderServices_};
      }
      else{
        
        data = {"accountid":this.listaccounts[i]['accountid'],"futureaction":this.futuremodel, "services":this.selectedOrderServices_};
      }
      
      this.partnerService.PostAddActivationBulky(data).subscribe((output: any) => {
        console.log(output);
        //this.listaccounts = output;
        this.messagesuccess[i] = output.data['success'];
        this.messageerror[i] = output.data['errors'];
        this.showproses[i] = false;
        
      })
    }  

  }
  

  

  

  
  

  
  
  totalService : number;
  totalServicepgw : number;

  // produk tanpa quota
  loadProducts(params:any) {
    return this.partnerService.GetProduct(params).subscribe((output: any) => {
      // console.log(output);
      this.ViewProduct = output;
      this.Layanan = this.ViewProduct.data;
      this.addCheckboxes();
      this.totalService = this.ViewProduct.meta.totalCount;
      
    })
  }

  


  

  
  loadsubLayanan()
  {
    return this.partnerService.GetSubServiceCustomer('?id='+this.customer['id']).subscribe((output: any) => {
      // console.log(output);
      this.subservices = output.data;
      
    });
  }

  onbuttonpgw()
  {

    this.searchproduct = ''
    let producttype = 3; // add on
    if ( this.customer['customersts'] == 0 ){
      producttype = 1; // starter
    }

    this.searchproduct = ''
    let _params = '?billingtype=1&producttype='+producttype;
    this.loadLayananpgw(_params);
  }

  onbuttondone(service)
  {

    this.settomodaldone(service);
  }

  onbuttonstockpromo()
  {
    
    let producttype = 4; // promo
    
    let searchText = this.searchpromo;
    //  _params = '?billingtype=1';
    let _params = '?search='+searchText;
        _params = _params+'&billingtype=1&producttype='+producttype;
      
    this.loadLayananpgw(_params);
  }

  searchLayananpgw()
  {
    let producttype = 3; // add on
    let billingtype = this.customer['billingtype']; 
    if ( this.producttype != undefined ){
      producttype = this.producttype;
    }

    if ( this.billingtypeid != undefined ){
      billingtype = this.billingtypeid;
    }
    
    if ( this.customer['customersts'] == 0 ){
      producttype = 1; // starter
    }

    let searchText = this.searchproduct;
    //  _params = '?billingtype=1';
    let _params = '?search='+searchText;
        _params = _params+'&billingtype='+billingtype+'&producttype='+producttype;
      
    this.loadLayananpgw(_params);
  }

  loadLayananpgw(params:any)
  {
    // only add ons
    // '?billingtype=1&producttype=2'
      return this.partnerService.GetProductatv(params).subscribe((output: any) => {
        // console.log(output);
        this.ViewProductpgw = output;
        this.Layananpgw = this.ViewProductpgw.data;
        this.addPgwCheckboxes();
        this.totalServicepgw = this.Layananpgw.length;
        
      });
    
  }

  //button

  searchService()
  {
    let searchText = this.searchproduct;
    //  _params = '?billingtype=1';
    let _params = '?search='+searchText;
        _params = _params+'&partnerid='+this.customer['partnerid'];
        _params = _params+'&billingtype='+this.customer['billingtype'];
        _params = _params+'&servicetype='+this.customer['servicetype'];
      
    this.loadProducts(_params);
  }


  // loadServices(id: any){
    
  //   this.partnerService.GetServices(id).subscribe((output: any) => {
  //     console.log(output);
  //     this.Services = output.data;
  //   })
  // }

  

  // prepaid
  submitPgwNew()
  {
    //if ( this.customer['billingtype'] == 1 ) { // prepaid
     //   this.postOrderServicePrepaidPGW();
    //}

     this.SelectedOrderServicePGW();
  }

 

//------------ ACTIVATION ATV NEW --------------------

// activation service per record 
disableATVservice = [];
prosesaktifasi = [];
erroraktifasi = [];
errormsgaktifasi = [];


/* checkout = melakukan pembayaran  by quota */





/* CHECK SN DAN USER ID */

tocheckingsn = true;
ischeckingsn = false;
isactivation = false;
iserror = false;
msgerror = '';



//------------ END ACTIVATION ATV NEW --------------------



  


  setflag(id,key,val)
  {
    // console.log(id,key,val);
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = val;
    }
    if ( this.flagging[id][key] == undefined){
      this.flagging[id][key] = val;
    }

    this.flagging[id][key] = val;
    // console.log(this.flagging[id]);
  }

  flag(id,key){
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = false;
    }else if (this.flagging[id][key] == undefined ) {
      this.flagging[id][key] = false;
    }

//    console.log(this.flagging[id]);
//    console.log(this.flagging[id][key]);
    return this.flagging[id][key];
  }

  


  ButtonPretoPostSaving = false;
  ButtonSetToProst = false;
  

  MyPermission(p)
  {
    if ( this.permision == undefined ){
      return false;
    }
    
    if (this.permision.indexOf(p) > -1){
      return true;
    }else{
        return false;
    }

  }

  MyRole(p)
  {
    if ( this.roles == undefined ){
      return false;
    }
    
    if (this.roles == p ){
      return true;
    }else{
        return false;
    }

  }

  Servicefuture(service)
  {
    if ( service.future != undefined){
      return service.future.actiondate;
    }else{
      return '-';
    }
  }

  ServicefutureEnd(service)
  {
    if ( service.future != undefined){
      return service.future.periodeend;
    }else{
      return '-';
    }
  }

  isproductservice(_service)
  {

    if ( _service.producttypeid == 1 || _service.producttypeid == 2 || _service.producttypeid == 3 || _service.producttypeid == 4 || _service.producttypeid == 9){
      return true;
    }else{
      return false;
    }

  }


  settomodaldone(service)
  {
    this.varmodaldone = service;
    // console.log(this.varmodaldone);
  }

  

}



function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}


